import { graphql } from "@opensea/graphql"

export const ActionTimelineItemFragment = graphql(`
  fragment ActionTimelineItem on BlockchainAction {
    ... on BuyItemAction {
      __typename
      items {
        imageUrl
        id
      }
    }
    ... on AcceptOfferAction {
      __typename
      items {
        id
      }
    }
    ... on ItemApprovalAction {
      __typename
      item {
        collection {
          name
          imageUrl
        }
      }
    }
    ... on PaymentApprovalAction {
      __typename
      currency {
        id
        symbol
      }
    }
    ... on CreateListingsAction {
      items {
        id
      }
    }
    ... on CreateOffersAction {
      items {
        imageUrl
        id
      }
    }
    ... on UnwrapAction {
      __typename
      transactionSubmissionData {
        to
        chain {
          identifier
          nativeCurrency {
            symbol
          }
          wrappedNativeCurrency {
            symbol
          }
        }
      }
    }
    ... on WrapAction {
      __typename
      transactionSubmissionData {
        to
        chain {
          identifier
          nativeCurrency {
            symbol
          }
          wrappedNativeCurrency {
            symbol
          }
        }
      }
    }
    ... on MintAction {
      __typename
      collection {
        imageUrl
      }
    }
    ... on DropPublishAction {
      __typename
    }
    ... on SvmBuyItemsAction {
      __typename
      items {
        imageUrl
        id
      }
    }
    ... on ClaimTokenRewardAction {
      __typename
    }
  }
`)
